<template>
    <div class="compare">
        <div class="compare__chart" id="compare-container"></div>
        <p class="comment">De andere getoonde fondsen zijn de vijf fondsen die qua belegd vermogen het meest
            overeenkomen met het geselecteerde fonds:
            {{fondsSpecification}}.</p>
    </div>
</template>

<script>
    import Highcharts from 'highcharts';
    import  { fondsSpecification } from "../modules/Utils";
    import { reduce, maxBy, minBy } from 'lodash';

    export default {
        name: "Compare",
        props: {
            fondsen: Array,
            fonds: Object
        },
        computed: {
            fondsSpecification() {
                return fondsSpecification(this.fondsen, this.fonds);
            }
        },
        watch: {
            fondsen() {
                this.updateChart();
            }
        },
        mounted() {
            this.plotLineOrange = {
                id: 'orange',
                color: '#fc0', // Color value
                dashStyle: 'dash', // Style of the plot line. Default to solid
                value: 110, // Value of where the line will appear
                width: 2 // Width of the line
            };
            let series;

            if (this.fondsen) {
                series = this.getSeries(this.fondsen);
            } else {
                series = []
            }
            this.chart = Highcharts.chart('compare-container', {
                chart: {
                    type: 'spline'
                },
                title: {
                    text: ''
                },
                xAxis: {
                    type: 'datetime',
                    /*dateTimeLabelFormats: {
                        month: '%b \'%y',
                        year: '%Y'
                    }*/
                },
                yAxis: {
                    title: {
                        text: 'Dekkingsgraad (%)'
                    },
                    min: 0,
                    plotLines: [
                        {
                            id: 'red',
                            color: '#E32A2A', // Color value
                            dashStyle: 'dash', // Style of the plot line. Default to solid
                            value: 104.2, // Value of where the line will appear
                            width: 2 // Width of the line
                        },
                        this.plotLineOrange
                    ]
                },
                tooltip: {
                    headerFormat: '<b>{series.name}</b><br>',
                    pointFormat: '{point.x:%B %Y}: {point.y}%'
                },

                plotOptions: {
                    spline: {
                        marker: {
                            enabled: true
                        }
                    }
                },

                colors: ['#1E82FF', '#ccc', '#ccc', '#ccc', '#ccc', '#ccc'],
                series,
                credits: {
                    enabled: false
                }
            });
        },
        methods: {
            updateChart() {
                /* Update the orange plot line */
                this.chart.yAxis[0].removePlotLine('orange');
                this.plotLineOrange.value = this.fonds.vereisteDekkingsgraad;
                this.chart.yAxis[0].addPlotLine(this.plotLineOrange);

                /* Update chart extremes */
                const extremes = this.getMinMax(this.fondsen);
                this.chart.yAxis[0].setExtremes(extremes.min);

                const series = this.getSeries(this.fondsen);
                this.chart.update({series}, true, true);
            },
            getMinMax(fondsen) {
              const data = reduce(fondsen, (result, fonds) => {
                  return result.concat(fonds.series)
              }, []);
              const min = minBy(data, 'value').value - 5;
              const max = maxBy(data, 'value').value + 10;
              return { min, max };

            },
            getSeries(fondsen) {
                return this.fondsen.map((fonds, i) => {
                    return {
                        name: fonds.fonds,
                        index: 100 - i,
                        data: fonds.series.map(datapoint => {
                            return [
                                datapoint.timestamp,
                                datapoint.value
                            ]
                        })
                    }
                })
            }
        }
    }
</script>

<style lang="stylus">

</style>
